// extracted by mini-css-extract-plugin
export default {"container":"Qk-z","disabled":"Rk-z","subtotal":"Sk-z","legal":"Tk-z"};